// components/MyOrders.js
import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import "../../styles/myorders.css";
import "../../styles/command.css";
import Navbar from "../common/Navbar.jsx";
import Footer from "../common/Footer.jsx";
import { useCart } from "../../contexts/CartContext.jsx";

const MyOrders = () => {
  const navigate = useNavigate();
  const { clearCart } = useCart();
  const [orders, setOrders] = useState([]);
  const [filter, setFilter] = useState("all");
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    fetchUserOrders();
  }, []);

  const fetchUserOrders = async () => {
    const userData = localStorage.getItem("userData");
    if (!userData) {
      navigate("/login");
      return;
    }

    const user = JSON.parse(userData);
    setIsLoading(true);

    try {
      const response = await fetch(
        `${import.meta.env.VITE_API_URL}/api/orders/client/${user.id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("clientToken")}`,
          },
        }
      );

      if (!response.ok) throw new Error("Failed to fetch orders");

      const data = await response.json();
      setOrders(data);
    } catch (err) {
      setError(err.message);
      console.error("Fetch orders error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const viewOrderDetails = (orderId) => navigate(`/order/${orderId}`);

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "pending":
        return "#ffbb00e1";
      case "processing":
        return "#2196f3";
      case "ready":
        return "#4caf50";
      case "payed":
        return "#27ae60";
      case "delivered":
        return "#009688";
      default:
        return "#9e9e9e";
    }
  };

  const getStatusIcon = (status) => {
    switch (status?.toLowerCase()) {
      case "pending":
        return <i className="fa-solid fa-clock"></i>;
      case "processing":
        return <i className="fa-solid fa-gears"></i>;
      case "ready":
        return <i className="fa-solid fa-box-open"></i>;
      case "payed":
        return <i className="fa-solid fa-money-bill-wave"></i>;
      case "delivered":
        return <i className="fa-solid fa-truck"></i>;
      default:
        return <i className="fa-solid fa-file"></i>;
    }
  };

  const formatDate = (dateString) =>
    new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

  const calculateTotalItems = (order) =>
    order.OrderItems?.reduce((total, item) => total + item.quantity, 0) || 0;

  const filteredOrders = orders
    .filter((order) => {
      const matchesFilter =
        filter === "all" || order.state?.toLowerCase() === filter.toLowerCase();
      const matchesSearch =
        order.id?.toString().includes(searchTerm) ||
        order.OrderItems?.some((item) =>
          item.productName?.toLowerCase().includes(searchTerm.toLowerCase())
        );
      return matchesFilter && (searchTerm === "" || matchesSearch);
    })
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

  const orderStats = {
    total: orders.length,
    pending: orders.filter((o) => o.state?.toLowerCase() === "pending").length,
    delivered: orders.filter((o) => o.state?.toLowerCase() === "delivered")
      .length,
    totalSpent: orders.reduce(
      (total, order) => total + parseFloat(order.totalPrice || 0),
      0
    ),
  };

  if (!localStorage.getItem("userData")) {
    navigate("/login");
    return null;
  }

  const statuses = [
    "all",
    "pending",
    "processing",
    "ready",
    "payed",
    "delivered",
  ];

  const OurPaymentMethods = () => {
    const paymentMethods = [
      {
        bankName: "Lumicash",
        accountName: "ndacayisaba Elyse",
        accountNumber: "AGENTCode: 50877",
        image: "../images/lumicash.png",
      },
      {
        bankName: "Bancobu",
        accountName: "iblotec",
        accountNumber: "16151940401",
        image: "../images/bancobu.jpg",
      },
      {
        bankName: "Bancobu Enoti",
        accountName: "iblotec",
        accountNumber: "89034",
        image: "../images/enoti.png",
      },
      /*{
        bankName: "My Legacy Coin",
        accountName: "comming soon...",
        accountNumber: "coming soon...",
        image: "../images/mlc.jpg",
      },
      */
      {
        bankName: "Coopec",
        accountName: "iblotec",
        accountNumber: "57676",
        image: "../images/coopec.png",
      },

      {
        bankName: "iHela",
        accountName: "iblotec",
        accountNumber: "97704-01",
        image: "../images/ihela.png",
      },

      {
        bankName: "paypal",
        accountName: "iblotec",
        accountNumber: "coming soon...",
        image: "../images/paypal.png",
      },

      {
        bankName: "VISA",
        accountName: "iblotec",
        accountNumber: "coming soon...",
        image: "../images/visa.png",
      },

      {
        bankName: "mastercard",
        accountName: "iblotec",
        accountNumber: "coming soon",
        image: "../images/mastercard.png",
      },
    ];

    return (
      <div className="payment-methods">
        <h2>Our Payment Methods</h2>
        <div className="payment-methods-grid">
          {paymentMethods.map((method, index) => (
            <div key={index} className="payment-method-card">
              <img src={method.image} alt={method.bankName} />
              <h3>{method.bankName}</h3>
              <p>Account Name: {method.accountName}</p>
              <p>Account Number: {method.accountNumber}</p>
            </div>
          ))}
        </div>
      </div>
    );
  };
  return (
    <div className="my-orders-container">
      <Navbar />

      <div className="orders-header">
        <div className="header-content">
          <h1>
            <i className="fa-solid fa-receipt"></i> My Orders
          </h1>
          <p>Track and manage your purchases</p>
        </div>
      </div>

      <div className="orders-dashboard">
        {/* Stats */}
        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-icon">
              <i className="fa-solid fa-cart-shopping"></i>
            </div>
            <div className="stat-info">
              <h3>{orderStats.total}</h3>
              <p>Total Orders</p>
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-icon">
              <i className="fa-solid fa-clock"></i>
            </div>
            <div className="stat-info">
              <h3>{orderStats.pending}</h3>
              <p>Pending</p>
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-icon">
              <i className="fa-solid fa-truck"></i>
            </div>
            <div className="stat-info">
              <h3>{orderStats.delivered}</h3>
              <p>Delivered</p>
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-icon">
              <i className="fa-solid fa-money-bill-wave"></i>
            </div>
            <div className="stat-info">
              <h3>{orderStats.totalSpent.toLocaleString()} Fbu</h3>
              <p>Total Spent</p>
            </div>
          </div>
        </div>

        {/* Controls */}
        <div className="orders-controls">
          <div className="search-box">
            <input
              type="text"
              placeholder="Search orders or products..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
            <span className="searchicon">
              <i className="fa-solid fa-search"></i>
            </span>
          </div>

          <div className="filter-buttons">
            {statuses.map((status) => (
              <button
                key={status}
                onClick={() => setFilter(status)}
                className={`filter-btn ${filter === status ? "active" : ""}`}
                style={{
                  backgroundColor:
                    filter === status ? getStatusColor(status) : "transparent",
                  color: filter === status ? "white" : getStatusColor(status),
                  border: `1px solid ${getStatusColor(status)}`,
                }}
              >
                {getStatusIcon(status)}{" "}
                {status.charAt(0).toUpperCase() + status.slice(1)}
              </button>
            ))}
          </div>
        </div>

        {/* Orders */}
        {isLoading ? (
          <div className="loading-container">
            <div className="loading-spinner">
              <i className="fa-solid fa-spinner fa-spin"></i>
            </div>
            <p>Loading your orders...</p>
          </div>
        ) : error ? (
          <div className="error-container">
            <div className="error-icon">
              <i className="fa-solid fa-triangle-exclamation"></i>
            </div>
            <h3>Unable to load orders</h3>
            <p>{error}</p>
            <button onClick={fetchUserOrders} className="retry-btn">
              <i className="fa-solid fa-rotate-right"></i> Try Again
            </button>
          </div>
        ) : filteredOrders.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">
              <i className="fa-solid fa-cart-shopping"></i>
            </div>
            <h3>No orders found</h3>
            <p>
              {searchTerm || filter !== "all"
                ? "Try adjusting your search or filter criteria"
                : "You haven't placed any orders yet"}
            </p>
            {!searchTerm && filter === "all" && (
              <Link to="/market" className="shop-now-btn">
                <i className="fa-solid fa-bag-shopping"></i> Start Shopping
              </Link>
            )}
          </div>
        ) : (
          <div className="orders-list">
            {filteredOrders.map((order) => (
              <div key={order.id} className="order-card">
                {/* Order Header */}
                <div className="order-header">
                  <div className="order-info">
                    <h3>
                      <i className="fa-solid fa-receipt"></i> Order #{order.id}
                    </h3>
                    <p className="order-date">
                      <i className="fa-solid fa-calendar-days"></i>{" "}
                      {formatDate(order.createdAt)}
                    </p>
                  </div>
                  <div className="order-status">
                    <span
                      className="status-badge"
                      style={{ backgroundColor: getStatusColor(order.state) }}
                    >
                      {getStatusIcon(order.state)} {order.state?.toUpperCase()}
                    </span>
                  </div>
                </div>

                {/* Order Preview */}
                <div className="order-preview">
                  <div className="order-items-preview">
                    {order.OrderItems?.slice(0, 3).map((item, index) => (
                      <img
                        key={index}
                        src={`${import.meta.env.VITE_API_URL}/${item.productImage}`}
                        alt={item.productName}
                        className="item-thumbnail"
                      />
                    ))}
                    {order.OrderItems?.length > 3 && (
                      <div className="more-items">
                        +{order.OrderItems.length - 3} more
                      </div>
                    )}
                  </div>

                  <div className="order-summary">
                    <div className="summary-item">
                      <span>
                        <i className="fa-solid fa-cube"></i> Items:
                      </span>
                      <span>{calculateTotalItems(order)}</span>
                    </div>
                    <div className="summary-item">
                      <span>
                        <i className="fa-solid fa-money-bill-wave"></i> Total:
                      </span>
                      <span className="order-total">
                        {parseFloat(order.totalPrice || 0).toLocaleString()} Fbu
                      </span>
                    </div>
                  </div>
                </div>

                {/* Order Actions */}
                <div className="order-bottom">
                  {!order.paymentProof &&
                    ["ready", "pending", "processing"].includes(
                      order.state
                    ) && (
                      <Link
                        to={`/upload-payment/${order.id}`}
                        className="upload-proof-btn"
                      >
                        <i className="fa-solid fa-upload"></i> Upload Payment
                        Proof
                      </Link>
                    )}

                  {order.paymentProof && (
                    <div className="payment-proof-info">
                      <span className="proof-status">
                        Proof{" "}
                        {order.paymentStatus === "verified"
                          ? "Verified"
                          : order.paymentStatus === "rejected"
                          ? "Rejected"
                          : "Pending Review"}
                      </span>
                      <a
                        href={`${import.meta.env.VITE_API_URL}/${order.paymentProof}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="view-proof-btn"
                      >
                        <i className="fa-solid fa-eye"></i> Proof
                      </a>
                    </div>
                  )}

                  <button
                    onClick={() => viewOrderDetails(order.id)}
                    className="view-details-btn"
                  >
                    <i className="fa-solid fa-eye"></i> See Details
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <OurPaymentMethods />
      <Footer />
    </div>
  );
};

export default MyOrders;
